import LayoutUtils from 'src/utils/layout_utils';

/**
 * Init expand/collapse toggle for the screening section body.
 */
export function initScreeningSection(popup) {
  const toggle = popup.querySelector('.js-showing-view-screening-toggle');
  const body = popup.querySelector('.js-showing-view-screening-body');
  if (!toggle || !body || toggle.dataset.bound === 'true') {
    return;
  }

  toggle.dataset.bound = 'true';
  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    LayoutUtils.toggle(body, !expanded);
  });
}
